import { render } from "./ElectionsFooter.vue?vue&type=template&id=1f64a362"
import script from "./ElectionsFooter.vue?vue&type=script&lang=js"
export * from "./ElectionsFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__